import React, { useEffect, useState } from "react";
import { FormSection } from "./styles";
import Labelize from "../../../../../common/Labelize";
import Pills from "../../../../../common/Pills";
import AddNewQuestionButton from "./AddNewQuestionButton";
import QuestionForm from "./QuestionForm";

const RoleTab = ({
  role,
  applicationForm,
  setApplicationForm,
  setUpdatedField,
  programForm
}) => {
  const key = role.toLowerCase();
  return (
    <FormSection>
      <Labelize
        horizontal
        applicationLabel={true}
        label={`Allow New Members to Apply as ${role}?`}
      >
        <Pills
          value={applicationForm.accepts[key]}
          applicationPills={true}
          setValue={(newValue) => {
            setApplicationForm({
              ...applicationForm,
              accepts: {
                ...applicationForm.accepts,
                [key]: newValue,
              },
            });
          }}
          options={[
            { label: "Yes", value: true },
            { label: "No", value: false },
          ]}
        />
      </Labelize>

      {applicationForm[key]
        .filter((question) => !question.deletedAt)
        .map((question, index) => {
          return (
            <QuestionForm
              key={question.id || question.customId}
              index={index}
              role={role}
              question={question}
              applicationForm={applicationForm}
              setUpdatedField={setUpdatedField}
              setApplicationForm={setApplicationForm}
              programForm={programForm}
            />
          );
        })}

      {applicationForm.accepts[key] && (
        <AddNewQuestionButton
          role={role}
          applicationForm={applicationForm}
          setApplicationForm={setApplicationForm}
        />
      )}
    </FormSection>
  );
};

export default RoleTab;
